module.exports = __webpack_public_path__ + "img/about-bg.9a613c85.webp";